import type { ChartOptions } from "chart.js";

export const defaultLineChartOptions: ChartOptions<"line"> = {
  plugins: {
    legend: {
      display: false,
    },
    tooltip: {
      callbacks: {
        label: (ctx) => `Preis je Gramm: ${ctx.raw}`,
      },
    },
  },
  elements: {
    point: {
      radius: 1.5,
    },
  },
  scales: {
    x: {
      type: "time",
      time: {
        unit: "year",
      },
      display: true,
      grid: {
        display: false,
      },
      ticks: {
        source: "data",
        autoSkip: true,
        maxRotation: 0,
        minRotation: 0,
      },
    },
    y: {
      display: true,
      grid: {
        display: true,
        drawOnChartArea: true,
        drawTicks: true,
      },
    },
  },
};
